module.exports = __webpack_public_path__ + "static/media/Runway.f0a118cb.glb";